<template>
  <transition name="modal-fade">
    <div class="modal-overlay" @click.self="close">
      <div class="modal-container">
        
        <header class="modal-header">
          <div class="modal-title">
            <slot name="title">Título do Modal</slot>
          </div>
          <button class="btn-close" @click="close" aria-label="Fechar">
            <span class="material-icons-outlined">close</span>
          </button>
        </header>
        
        <main class="modal-body">
          <slot></slot>
        </main>
        
        <footer class="modal-footer" v-if="$slots.actions">
          <slot name="actions"></slot>
        </footer>
      
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  name: "BaseModal",
  methods: {
    close() {
      this.$emit('close');
    }
  },
  mounted() {
    // Bloqueia o scroll do body quando o modal abre
    document.body.style.overflow = 'hidden';
  },
  beforeDestroy() {
    // Libera o scroll do body ao fechar
    document.body.style.overflow = '';
  }
};
</script>

<style scoped>
/* --- Overlay (Fundo escuro) --- */
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh; /* Fallback */
  height: 100dvh; /* Altura dinâmica real (considera barra de navegação mobile) */
  background-color: var(--bg-modal-overlay, rgba(0, 0, 0, 0.7));
  z-index: 9999;
  display: flex;
  justify-content: center;
  align-items: center;
}

/* --- Container do Modal --- */
.modal-container {
  background-color: var(--bg-card);
  color: var(--text-main);
  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.5);
  display: flex;
  flex-direction: column;
  overflow: hidden;
  transition: all 0.3s ease-out;
  
  /* Garante que o modal nunca seja maior que a tela */
  max-height: 100%;
}

/* --- Header --- */
.modal-header {
  flex-shrink: 0;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 15px 20px;
  background-color: var(--bg-header);
  border-bottom: 1px solid var(--border-light);
}

.modal-title {
  font-size: 1.25rem;
  font-weight: 700;
  color: var(--text-hero);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.btn-close {
  background: none;
  border: none;
  color: var(--text-secondary);
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 5px;
  border-radius: 50%;
  transition: background 0.2s;
}

.btn-close:hover {
  background-color: var(--bg-icon-hover-light);
  color: var(--text-main);
}

/* --- Body (Conteúdo com Scroll) --- */
.modal-body {
  flex: 1 1 auto; /* Cresce e ENCOLHE conforme necessário */
  overflow-y: auto; /* Scroll interno vital quando o teclado sobe */
  padding: 20px;
  -webkit-overflow-scrolling: touch;
  min-height: 0; /* Hack importante para flexbox aninhado com scroll */
}

/* --- Footer (Ações) --- */
.modal-footer {
  flex-shrink: 0; /* Nunca encolhe, sempre visível se houver espaço */
  padding: 15px 20px;
  border-top: 1px solid var(--border-light);
  background-color: var(--bg-main);
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  /* Garante que fique acima de teclados mal-comportados em alguns browsers */
  z-index: 10;
}

/* =========================================
   COMPORTAMENTO RESPONSIVO
   ========================================= */

/* PC: Flutuante, centralizado */
@media (min-width: 769px) {
  .modal-container {
    width: 600px;
    max-width: 90%;
    max-height: 85vh;
    border-radius: 8px;
    border: 1px solid var(--border-light);
  }
}

/* MOBILE: Bottom sheet ajustável ao teclado */
@media (max-width: 768px) {
  .modal-overlay {
    align-items: flex-end;
  }
  
  .modal-container {
    width: 100%;
    /* IMPORTANTE:
       Em vez de max-height fixo com calc, usamos uma altura flexível.
       Quando o teclado abre, o viewport (100dvh) diminui.
       O flexbox vai forçar o .modal-body a encolher e criar scroll.
    */
    max-height: 90dvh; /* Limite máximo visual */
    
    border-top-left-radius: 16px;
    border-top-right-radius: 16px;
    border-bottom-left-radius: 0;
    border-bottom-right-radius: 0;
    
    animation: slideUp 0.3s ease-out;
  }
}

/* --- Animações --- */
.modal-fade-enter-active, .modal-fade-leave-active { transition: opacity 0.3s ease; }
.modal-fade-enter, .modal-fade-leave-to { opacity: 0; }

@keyframes slideUp {
  from { transform: translateY(100%); }
  to { transform: translateY(0); }
}
</style>